module.exports = __webpack_public_path__ + "static/media/emailPhishing.0311a2c5.png";